import { useContext } from 'react'
import { TrackControllerContext } from './trackControllerState'

export function useTrackController() {
    const trackController = useContext(TrackControllerContext)
    if (!trackController) {
        throw new Error('useTrackController must be used inside TrackControllerProvider')
    }
    return trackController
}